import { takeLeading } from 'redux-saga/effects';
import { callApi } from 'helpers/saga-helpers';
import { get, isNull } from 'lodash';
import userToken from 'containers/services/security/access-token-storage';
import { REQUEST_PREOPEN_MANAGER_REJECTED_CLAIMS } from 'containers/PreOpenManagerRejectedClaims/constants';
import { setRejectedClaims } from 'containers/PreOpenManagerRejectedClaims/actions';
import currentUserStorage from 'containers/services/security/current-user-storage';

export function* requestRejectedClaims(action: {
  status: string;
  page: number;
  pageSize: number;
  type: string;
}): Generator<unknown> {
  const { status, page, pageSize } = action;
  const token = get(userToken.get(), 'token');
  if (isNull(token)) return;
  const path = `/corporeal/common/claims?status=${status}&page=${page}&pageSize=${pageSize}`;
  const options = {
    method: 'GET',
    headers: {
      Authorization: `Bearer ${token}`,
      name: get(currentUserStorage.get(), 'username'),
    },
  };
  yield callApi(path, {}, options, [], setRejectedClaims);
}

export function* requestPreOpenManagerRejectedClaimsSaga() {
  yield takeLeading(
    REQUEST_PREOPEN_MANAGER_REJECTED_CLAIMS,
    requestRejectedClaims,
  );
}

export default [requestPreOpenManagerRejectedClaimsSaga];
